import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { findPathToActiveItem } from '~/components/ConsumerSideNavigation/helpers'
import { NestedSideNavItem } from '~/components/ConsumerSideNavigation/NestedSideNavItem'
import { PublishedTableOfContents } from '~/types/content'

export const ConsumerSideNavigation = ({
  tableOfContents,
  onClick,
}: {
  tableOfContents: PublishedTableOfContents[],
  accentColor?: string,
  onClick?: (e: any) => void,
}) => {

  const { t } = useTranslation()
  const location = useLocation()

  const defaultOpenIds = useMemo(() => findPathToActiveItem(tableOfContents, location.pathname), [location.pathname])

  return (
    <div className="flex flex-col h-full">
      <div aria-label={t('consumer.sideNavigation.ariaLabel')} data-testid="consumer-side-navigation" className="flex-grow overflow-auto dark:bg-neutral-98">
        {tableOfContents.map(tocItem => (
          <NestedSideNavItem key={tocItem.path} tocItem={tocItem} level={0} openIds={defaultOpenIds} onClick={onClick} />
        ))}
      </div>
    </div>
  )
}